import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import Strings from "@my-dld/assets/strings";
import EjariActionSuccessPage from "../EjariActionSuccessPage";

interface Props extends RoutedViewProps<any> {

}


interface State {

}

class TerminateSuccess extends Component<Props, State> {


	render() {
		return <EjariActionSuccessPage
			message={ Strings.contract_termination_success }
			title={ Strings.terminate_contract }
			buttonTitle={ Strings.continue }
			refreshProperty={ true }
			{ ...this.props }
		/>;
	}


}

export default TerminateSuccess;
